module.exports = __webpack_public_path__ + "img/invoiceDisAct.6621e25d.png";